import script from "./LatexStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./LatexStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./LatexStylePanel.vue?vue&type=style&index=0&id=3a5ca316&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5ca316"]])

export default __exports__